module.exports = "https://99designs-start-assets.imgix.net/js/af9fd47697c26ed9bc52733e6fa2a4b8.jpg";